<div
    class="tw-bg-[#0A0A75] tw-text-white tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-between tw-gap-10 tw-relative tw-pt-8 md:tw-pt-4"
>
    <!-- Left Content -->
    <div
        class="tw-text-center sm:tw-text-left tw-relative tw-z-10 md:tw-w-1/2 tw-px-6 lg:tw-pl-20 lg:tw-pr-3"
    >
        <p
            class="tw-w-full tw-text-[32px] md:tw-text-[40px] tw-text-white tw-font-bold"
        >
            {{ "ABOUT_IMSME" | translate }}
        </p>
        <p class="tw-text-[14px] md:tw-text-[16px] tw-mb-6 tw-font-normal">
            {{ "ABOUT_IMSME_DESC" | translate }}
        </p>
    </div>

    <!-- Right Content -->
    <div class="tw-w-full md:tw-w-1/2">
        <img
            src="../../../assets/images/About-us/about_us_mobile.webp"
            alt="Business Financing"
            class="tw-w-full tw-h-auto tw-max-h-[350px] lg:tw-max-h-[500px] md:tw-hidden"
        />
        <img
            src="../../../assets/images/About-us/about_us_desktop.webp"
            alt="Business Financing"
            class="tw-w-full tw-h-auto tw-hidden md:tw-block"
        />
    </div>
</div>
